<p-tabs value="{{activeTabIndex}}" *ngIf="!isOpened">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      [severity]="'success'" [variant]="undefined" (onClick)="newRegister()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-table [showImport]="false" [showExport]="true" [showRecover]="true" [headers]="header" [data]="data"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="url"
        (onRecoverData)="getAllTransportInvoicesWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()" (onAction)="onAction($event)">
      </app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader.columns" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [listDifferences]="listDifferences"
        [differences]="differences" [filterPersistentKey]="url"
        (onRecoverData)="getTransportInvoicesDetailsForDetailConsultation()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (differencesEmit)="onDifferencesChange($event)"
        (onExport)="onExport()" (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>